// Femcare date widget
// Stateful plugin implemented using jquery-ui widget factory https://jqueryui.com/widget/

(function($) {
    $.widget('femcare.multiFieldDate', {
        options: {
            format: null
        },

        daysPerMonth: [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

        $day: null,
        $month: null,
        $year: null,
        $date: null,

        _create: function() {
            this.$day = this.element.find('.form-day');
            this.$month = this.element.find('.form-month');
            this.$year = this.element.find('.form-year');
            this.$date = this.element.find('input[type="hidden"]');

            this.$day.on('blur', $.proxy(this.onDayBlur, this));
            this.$month.on('change', $.proxy(this.onMonthChange, this));
            this.$year.on('blur', $.proxy(this.onYearBlur, this));
        },

        onDayBlur: function() {
            this.sanitizeNumberInput(this.$day);
            this.updateDate();
        },

        onMonthChange: function() {
            this.resetDaysLimit();
            this.$day.validate();
            this.updateDate();
        },

        onYearBlur: function() {
            this.sanitizeNumberInput(this.$year);
            this.resetDaysLimit();
            this.$month.validate();
            this.$day.validate();
            this.updateDate();
        },

        sanitizeNumberInput: function($input) {
            $input.val(parseInt($input.val(), 10));
        },

        resetDaysLimit: function() {
            var month = this.$month.val() && parseInt(this.$month.val(), 10);
            var year = this.$year.val() && parseInt(this.$year.val(), 10);
            var daysInMonthCount = null;

            if (month && year) {
                daysInMonthCount = new Date(year, month, 0).getDate();
            } else if (month) {
                daysInMonthCount = this.daysPerMonth[month - 1];
            }

            if (daysInMonthCount) {
                this.$day.attr('max', daysInMonthCount);

                var day = this.$day.val() && parseInt(this.$day.val(), 10);

                if (day > daysInMonthCount) {
                    this.$day.val('');
                }
            }
        },

        updateDate: function() {
            var day = this.$day.val() || '';
            var month = this.$month.val() || '';
            var year = this.$year.val() || '';
            var date = '';

            if (day && month && year) {
                day = day < 10 ? '0' + day : day;
                month = month < 10 ? '0' + month : month;

                if (this.options.format == 'dd-mm-yyyy') {
                    date = day + '-' + month + '-' + year;
                } else if (this.options.format == 'yyyy-mm-dd') {
                    date = year + '-' + month + '-' + day;
                } else {
                    date = month + '-' + day + '-' + year;
                }
            }

            this.$date.val(date);
        }
    });
})(jQuery);
